const Role = {
    mmpladmin: 'admin',
    client: 'client',
    mmpl: 'mmpl',
    staff: 'staff',
    clientuser:'clientUser',
    consultant: 'consultant',
}
export default Role;